import React from 'react';
import CandidatesList from './Components/CandidatesList';
import CandidateAddSection from './Components/CandidateAddSection';
import { useInviteCandidateContext } from '../Contexts/InviteCandidateContext';

function AddCandidatesPanel(): React.JSX.Element {
    const { candidates } = useInviteCandidateContext();

    return (
        <div className="bg-card rounded-xl border p-5">
            <CandidateAddSection />
            {candidates.length > 0 && <CandidatesList />}
        </div>
    );
}

export default AddCandidatesPanel;
